import type { TPlayer } from 'video.js'
import type { TXhr } from '|>/shared/types/vhs'

import { logger } from '|>/shared/logger'

/**
 * Get VHS tech
 */
export function getVhs(player: TPlayer, name?: string) {
  const tech: any = player.tech(true)
  if (!tech) {
    return
  }

  const vhs = tech.vhs
  if (!vhs) {
    logger.warn(`${name ? name + ': ' : ''}VHS is not available`)
    return
  }

  return vhs
}

/**
 * Use this to access xhr
 * Using videojs.vhs.xhr causes xhr to lose callbacks
 */
export function getXhr(player: TPlayer, name?: string): TXhr | undefined {
  const vhs = getVhs(player, name)

  const xhr = vhs?.xhr
  if (!xhr) {
    logger.warn(`${name ? name + ': ' : ''}VHS does not expose xhr`)
    return
  }

  return xhr
}
